export class ISODateTimeOffset
{
	private static r: RegExp = new RegExp("^(\\d{4})-(\\d{2})-(\\d{2})T(\\d{2}):(\\d{2}):(\\d{2}).*([+-])(\\d{1,2}):(\\d{2})$");

	public static ConvertToStatusTime(st: string): string
	{
		let d = this.r.exec(st);
		if (!d || d.length === 0) return st;
		let year = d[1];
		let month = d[2];
		let day = d[3];
		let hour = d[4];
		let minute = d[5];
		//let second = d[6];
		let sign: string = d[7];
		let hourOffset: string = parseInt(d[8]).toString();
		return day + "." + month + "." + year + " " + hour + ":" + minute + " МСК (GMT" + sign + hourOffset + ")";
	}
}
